'use strict';

var convert = require('./convert-51dab0c6.js');



module.exports = convert.convert;
